module.exports = __webpack_public_path__ + "static/media/ViaductMcDowellStAshevilleNC2006PencilandWatercoloronvintagepaper.dbe45784.webp";